import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ResultModalConfig } from '../../models/result-modal-config.model';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { UiLibraryModule } from "@template-ui/template-ui.module";

/**
 * @deprecated This component is deprecated and should not be used in new development.
 */
@Component({
    selector: 'app-result-modal',
    templateUrl: './result-modal.component.html',
    imports: [MatDialogModule, CommonModule, MatButtonModule, MatProgressBarModule, MatIconModule, UiLibraryModule],
    styleUrls: ['./result-modal.component.scss']
})

export class ResultModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ResultModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResultModalConfig
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
